import React from 'react'
import style from './layout.module.scss'

interface ILayout {
  header?: any
  leftPanel?: any
  middle?: any
  footer?: any
}
const Layout = ({ header: Header, leftPanel: LeftPanel, middle: Middle, footer: Footer }: ILayout) => {
  const getTemplate = () => {
    if (Header && Footer) {
      return style.wrapper
    }
    if (!Header && Footer) {
      return style.wrapperNoneHeader
    }
    if (Header && !Footer) {
      return style.wrapperNoneFooter
    }
    if (!Header && !Footer) {
      return style.wrapperNoneHeaderFooter
    }
  }
  return (
    <div className={getTemplate()}>
      {Header && (
        <div className={style.header}>
          <Header />
        </div>
      )}
      <div className={LeftPanel ? style.middle : style.main}>
        {LeftPanel && <LeftPanel />}
        <div className={style.main}>{Middle && <Middle />}</div>
      </div>
      {Footer && (
        <div className={style.footer}>
          <Footer />
        </div>
      )}
    </div>
  )
}

export default Layout
